import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgYAxis = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_416_7927)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M4.68726 2.75C4.68726 2.33579 4.35147 2 3.93726 2C3.52304 2 3.18726 2.33579 3.18726 2.75V21.25C3.18726 21.6642 3.52304 22 3.93726 22H22.1873C22.6015 22 22.9373 21.6642 22.9373 21.25C22.9373 20.8358 22.6015 20.5 22.1873 20.5H4.68726V2.75Z",
				fill: "var(--colors-grey-1)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.1873 8L12.9103 11.5871L15.6334 8",
				stroke: "var(--colors-grey-1)",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.9104 11.5869V14.3769",
				stroke: "var(--colors-grey-1)",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M0.211725 5.18714C0.056006 5.03142 0.0546528 4.78031 0.208703 4.62626L3.55588 1.2791C3.70993 1.12505 3.96104 1.12641 4.11676 1.28213L7.5002 4.66557C7.65592 4.82129 7.65728 5.0724 7.50323 5.22645C7.34918 5.3805 7.09806 5.37915 6.94234 5.22343L4.2396 2.52069L4.28079 10.1634C4.28197 10.3825 4.10536 10.5591 3.88632 10.5579C3.66728 10.5567 3.48876 10.3782 3.48758 10.1591L3.44638 2.51641L0.77261 5.19017C0.61856 5.34422 0.367443 5.34286 0.211725 5.18714Z",
				fill: "var(--colors-grey-1)"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_416_7927",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgYAxis;
